import React from "react";
import "./landingPage.css";
import image from "./landingPage.svg";

export const LandingPage = () => {
  return (
    <div className="landingPageWrapper">
      <div className="landingPage">
        <img src={image} alt="landingPageImage" />
        <div className="landingText">
          <div className="headingText">
            Simplified living
            <br />
            Transforming lives
          </div>
          <div className="doubleHr">
            <hr /> X X X <hr />
          </div>
          <div className="normalText">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </div>
          <a href="#companyInfo"><div className="downArrow"></div></a>
        </div>
      </div>
    </div>
  );
};
